module.exports = __webpack_public_path__ + "static/media/DSC_1616.e2d9cf50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/DSC_1616.jpg
// module id = 476
// module chunks = 0